import i18next from 'i18next';
import { OverviewDashboardInteractionTime } from 'infrastructure/enums';

export interface IOverviewDashboardInteractionTimeItem {
  id: OverviewDashboardInteractionTime | null;
  name: string;
}

export const overviewDashboardDataSource = (
  withNone = true,
): IOverviewDashboardInteractionTimeItem[] => {
  const dataSource: IOverviewDashboardInteractionTimeItem[] = [
    {
      id: OverviewDashboardInteractionTime.LessThan20,
      name: i18next.t('overviewDashboard.lessThan20'),
    },
    {
      id: OverviewDashboardInteractionTime.From21To40,
      name: i18next.t('overviewDashboard.21to40'),
    },
    {
      id: OverviewDashboardInteractionTime.From41To55,
      name: i18next.t('overviewDashboard.41to55'),
    },
  ];

  if (withNone) {
    dataSource.unshift({
      id: null,
      name: i18next.t('overviewDashboard.all'),
    });
  }

  return dataSource;
};
